import { render } from "./FinishTranferWork.vue?vue&type=template&id=68e1d710"
import script from "./FinishTranferWork.vue?vue&type=script&lang=js"
export * from "./FinishTranferWork.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__